/**
 * Helper to hide the form and show a success message
 * after Freeform Ajax submission is successful
 *
 * Steps:
 * - Enable AJAX on form in Freeform
 * - Markup should be similar to below:
 *
 <div data-form-wrapper>
    {{ freeform.form.whatever.method.you.use }}
    <div data-success>
        {{ form.successMessage }}
    </div>
 </div>
 *
 * The success message is dependent on the form Twig object. If you do
 * not have or need access to that for the message, you can insert whatever
 * you want inside of the [data-success] selector, as long as it is nested inside
 * the same [data-form-wrapper] tag as the form it is the success message for
*/

const forms = document.querySelectorAll('form[data-ajax]');
const wrapperSelector = '[data-form-wrapper]';
const messageSelector = '[data-success]';
const submittingClass = 'opacity-50';

forms.forEach(form => {
    let wrapper = form.closest(wrapperSelector);
    if(typeof(wrapper) === 'undefined' || wrapper === null) {
        return false;
    }
    let successMessage = wrapper.querySelector(messageSelector);

    if(typeof(form) === 'undefined' || typeof(successMessage) === 'undefined' || !form || !successMessage) {
        return false;
    }
    form.addEventListener('freeform-ready', function(event) {
        const freeform = event.target.freeform;
        freeform.addOnSuccessfulAjaxSubmit(function(event, form, response) {
            handleSuccess(form, successMessage);
        })
    });
})

function handleSuccess(form, message) {
    form.style.display = 'none';
    message.style.display = 'block';
}
